import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { ColorVariantType } from "../../../../types";

interface InputLabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement>,
    ColorVariantType {
  additionalClassname?: string;
  size?: "sm" | "md" | "lg";
  required?: boolean;
  requiredColor?: "default" | "red";
  truncate?: boolean;
}

const LABEL_CLASS = {
  base: "tw-block tw-font-medium tw-py-1",
  variant: {
    default: "",
    primary: "tw-text-primary-500",
    secondary: "tw-text-secondary-500",
    info: "tw-text-blue-500",
    success: "tw-text-green-500",
    warning: "tw-text-yellow-500",
    danger: "tw-text-red-500",
  },
  size: {
    sm: "tw-text-sm",
    md: "tw-text-md",
    lg: "tw-text-lg",
  },
  required: "tw-ml-0.5",
  requiredColor: {
    default: "",
    red: "tw-text-red-500",
  },
  truncate: "tw-truncate",
};

const Label: React.FC<InputLabelProps> = ({
  variant = "default",
  size = "md",
  additionalClassname,
  required,
  requiredColor = "default",
  children,
  truncate = true,
  ...props
}) => {
  const defaultClass: string = classNames(
    LABEL_CLASS.base,
    LABEL_CLASS.variant[variant],
    LABEL_CLASS.size[size],
    truncate && LABEL_CLASS.truncate,
    additionalClassname
  );
  let customClass: string = defaultClass;
  if (props.className) {
    customClass = props.className;
  }

  return (
    <label className={customClass} {...props}>
      {children}
      {required && (
        <span
          className={classNames(
            LABEL_CLASS.required,
            LABEL_CLASS.requiredColor[requiredColor]
          )}
        >
          *
        </span>
      )}
    </label>
  );
};

Label.propTypes = {
  requiredColor: PropTypes.oneOf(["default", "red"]),
};

export default Label;
